<template>
  <section class="layout-pt-lg layout-pb-lg" :style="styles">
    <div class="container">
      <div v-if="vars.titleText || vars.titleHtml" class="text-center mb-16">
        <h2
          v-if="vars.titleText"
          :style="{ color: String(vars.textColor) }"
        >
          {{ vars.titleText }}
        </h2>
        <div
          v-else
          :style="{ color: String(vars.textColor) }"
          v-html="vars.titleHtml"
        />
      </div>

      <div
        v-if="cards && cards.length"
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2  tw-gap-x-8 tw-gap-y-12"
      >
        <CaseStudyCard
          v-for="(card, index) in cards"
          :key="index"
          :photo="String(card.photo)"
          :title="String(card.title)"
          :link="String(card.link)"
          :text-color="String(vars.textColor)"
          :button-label="String(vars.cardsButtonLabelText)"
          :button-type="String(vars.cardsButtonTypeText)"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app';
import { ComponentMixin } from '~/mixins/component.mixin';
import CaseStudyCard from './CaseStudyCard.vue';

export default defineNuxtComponent({
  name: 'CaseStudies',

  components: {
    CaseStudyCard,
  },

  mixins: [ComponentMixin],

  computed: {
    styles(): { [key: string]: string } {
      const styles: { [key: string]: string } = {};
      if (this.vars.backgroundColor) {
        styles.backgroundColor = String(this.vars.backgroundColor);
      }
      return styles;
    },

    cards() {
      return this.groupedVariables?.cards || [];
    },
  },
});
</script>
